module.exports = __webpack_public_path__ + "img/slide_001_h3.b4b3061d.jpg";